// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__16qWE","mini":"style_mini__5cq3u","cover":"style_cover__hOjas","full":"style_full__bj_N8","progress":"style_progress__1NmdP"};